<template>
  <div>
    <div class="text-center my-4 p-4">
      <h1 class="text-xl font-extrabold p-2">Thank you</h1>
      <div>Thank you for completing your Member Review.</div>
      <div>Before clicking the 'Submit' button, please check that each section has been completed and they are all showing as green ticks, please resolve any unticked sections before submitting. </div>
      <div>Once submitted the review is no longer editable. </div>
      <div class="border-b p-4 flex justify-between cursor-pointer" v-for="(value,index) in completeStatus" :key="index" @click="goPage(value.page)">
        <div>{{index+1}}. {{value.name}}</div>
        <div>
          <div class="flex items-center justify-center rounded-full w-10 h-10 bg-green transition scale-out" v-if="value.value === 2">
            <span class="fas fa-check text-2xl text-white"></span>
          </div>
          <div class="flex items-center justify-center rounded-full w-10 h-10 bg-yellow transition scale-out" v-else-if="!value.value">
            <span class="fas fa-exclamation-triangle text-lg"></span>
          </div>
          <div class="flex items-center justify-center rounded-full w-10 h-10 bg-grey transition scale-out" v-else>
            <span class="fas fa-minus text-lg"></span>
          </div>
        </div>
      </div>
      <div class="pt-2 bg-grey-lighter rounded p-8">
        <div class="text-lg font-black py-2 text-center">Recipients</div>
        <div>The following individuals will receive a pdf version of the Member Review Form by email</div>
        <div v-for="(recipient, index) in review.recipients" :key="index" class="flex justify-center items-center pt-4">
          <div class="mx-4">{{ recipient.recipient_email }}</div>
          <i class="fas fa-trash mr-4 cursor-pointer" @click="removeRecipient(index)" title="Remove this additional action"></i>
        </div>
        <div class="pt-4 flex justify-center items-center">
          <text-input v-model="newRecipientEmail" class-name="text-sm mx-4 w-1/2" placeholder="Recipient Email" :error="errorBag.get('recipient_email')"></text-input>
          <div class="text-green text-lg cursor-pointer" @click="addRecipient">+ Add new recipient</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'
import { v2Api } from '@/http'
import ErrorBag from '@/ErrorBag'

export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value,
      completeStatus: [
        { name: 'Local Market', value: 0, page: 1 },
        { name: 'Market Share Assessment', value: 0, page: 2 },
        { name: 'Growth Strategy', value: 0, page: 3 },
        { name: 'Membership Status', value: 0, page: 4 },
        { name: 'Use of Services', value: 0, page: 5 },
        { name: 'Use of Services continued', value: 0, page: 6 },
        { name: 'Administration Review', value: 0, page: 7 },
        { name: 'Member\'s Top Tips', value: 0, page: 8 },
        { name: 'Compliance', value: 0, page: 9 },
        { name: 'Guild Events', value: 0, page: 10 },
        { name: 'Feedback & improvements', value: 0, page: 11 },
        { name: 'Agreed actions and objectives', value: 0, page: 12 }
      ],
      incompletePages: [],
      newRecipientEmail: null,
      errorBag: new ErrorBag()
    }
  },
  mounted () {
    let flattenQuestions = this.flattenObject(this.form.questions, 3)
    for (let i = 1; i <= this.completeStatus.length; i++) {
      let sectionNumber = 0
      let completedNumber = 0
      for (let index in flattenQuestions) {
        if (parseInt(flattenQuestions[index].section_id) === i && flattenQuestions[index].mandatory) {
          sectionNumber++
          if (flattenQuestions[index].result !== null) {
            completedNumber++
          } else {
            if (!this.incompletePages.includes(flattenQuestions[index].page_id)) {
              this.incompletePages.push(flattenQuestions[index].page_id)
            }
            this.completeStatus[i - 1].page = (this.completeStatus[i - 1].page === 0 || this.completeStatus[i - 1].page > flattenQuestions[index].page_id) ? flattenQuestions[index].page_id : this.completeStatus[i - 1].page
          }
        }
      }
      this.completeStatus[i - 1].value = (sectionNumber !== completedNumber) ? 0 : sectionNumber === 0 ? 1 : 2
      // check member status page
      if (i === 4) {
        for (var emailIndex in this.review.memberStatus) {
          if (this.review.memberStatus[emailIndex].members_hub_profile === null && this.review.memberStatus[emailIndex].receiving_marketing_emails === null &&
            this.review.memberStatus[emailIndex].facebook_group_user === null && this.review.memberStatus[emailIndex].passed_associate_scheme === null &&
            this.review.memberStatus[emailIndex].active_referrals === null
          ) {
            this.completeStatus[i - 1].value = 0
            break
          }
          this.completeStatus[i - 1].value = 2
        }
      }
    }

    if (this.incompletePages.length > 0) {
      this.$emit('page-incomplete', this.incompletePages)
    }
  },
  methods: {
    flattenObject (ob, maxLevel = null) {
      var toReturn = {}
      if (maxLevel) {
        maxLevel--
      }
      for (var i in ob) {
        if (!ob.hasOwnProperty(i)) {
          continue
        }

        if ((typeof ob[i]) === 'object' && ob[i] !== null && maxLevel > 0) {
          var flatObject = this.flattenObject(ob[i], maxLevel)
          for (var x in flatObject) {
            if (!flatObject.hasOwnProperty(x)) {
              continue
            }

            toReturn[i + '.' + x] = flatObject[x]
          }
        } else {
          toReturn[i] = ob[i]
        }
      }
      return toReturn
    },
    goPage (page) {
      this.$emit('changePage', page)
    },
    addRecipient () {
      var newRecipient = {
        'id': null,
        'review_id': this.review.id,
        'recipient_email': this.newRecipientEmail
      }
      // send new recipient to backend
      v2Api.post(`/annual-reviews/recipients`, newRecipient).then((response) => {
        this.newRecipientEmail = null
        newRecipient.id = response.data.id
        this.review.recipients.push(newRecipient)
      }, (errors) => {
        this.errorBag.store(errors.response.data)
      })
    },
    removeRecipient (index) {
      // send new recipient to backend
      v2Api.delete(`/annual-reviews/recipients/${this.review.recipients[index].id}`).then((response) => {
        this.review.recipients.splice(index, 1)
      }, (errors) => {
        this.errorBag.store(errors.response.data)
      })
    }
  }
}
</script>
